import '@/lib/i18n';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { QueryProvider } from './QueryProvider';
import { ContextProvider } from './ContextProvider';
import { Toaster } from '@/components/ui/toaster';
import { AppRouterProvider } from './RouterProvider';

export function Providers() {
  return (
    <NuqsAdapter defaultOptions={ { shallow: false } }>
      <QueryProvider>
        <ContextProvider>
          <AppRouterProvider />
          <Toaster />
        </ContextProvider>
      </QueryProvider>
    </NuqsAdapter>
  );
}
